/* eslint-disable no-console */
<template>
  <div ref="bar4">

  </div>
</template>

<script>
var echarts = require('echarts');
export default {
  props: ['stars'],
  data() {
    return {
      option: {
        grid: {
          left: 40,
          top: 15,
          bottom: 30,
          right: 20
        },
        xAxis: {
            axisLabel: {
                textStyle: {
                    color: '#fff'
                },
                fontSize: 9
            },
            axisTick: {
                show: false
            }, 
            axisLine: {
                lineStyle: {
                  color: 'rgba(255, 255, 255, .7)',
                }
            }, 
            splitLine: {
              show: false
            },
            z: 10,
            data: [],
        },
        yAxis: {           
            axisLine: {
                lineStyle: {
                  color: 'rgba(255, 255, 255, .7)',
                }
            },
            axisTick: {
                show: false
            },
            splitLine: {
                lineStyle: {
                  type: 'dashed',
                  opacity: 0.7
                }
            },            
            axisLabel: {
                textStyle: {
                    color: '#fff',
                },
                fontSize: 9
            },
         
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
              type: 'shadow'
          }
        },        
        series: [
            {
                type: 'bar',
                itemStyle: {
                    normal: {
                        color: new echarts.graphic.LinearGradient(
                            0, 0, 0, 1,
                            [
                                {offset: 0, color: '#93FF8D'},
          
                                {offset: 1, color: '#00FCF9'}
                            ]
                        )
                    }
                },
                barWidth: 20,
                data: []
            }
        ]        
      },
    }
  },
  watch: {
    stars() {
     this.$nextTick(() => {
        this.setChart()
     })      
    }
  },
  methods: {
     setOption() {
        let names = [];
        let values = [];
        for (const key in this.stars) {
          if (this.stars.hasOwnProperty(key)) {
            const val = this.stars[key];
            if(key !== 'all'){
              if(key == 0) {
                names.push('未评')
              }else {
                names.push(key+'星');
              }
              values.push(val);
            }
          }
        }
        names = names.reverse();
        values = values.reverse();
        // eslint-disable-next-line no-console
        console.log(names, values);
        this.option.xAxis.data = names;
        this.option.series[0].data = values;
     },
     setChart () {
        this.setOption();
        let width = document.getElementsByClassName('pieWraper')[0].clientWidth;
        let height = document.getElementsByClassName('pieWraper')[0].clientHeight;
        var dom = this.$refs.bar4;
        dom.style.width = width + 'px';
        dom.style.height = height + 'px';
        var myChart = echarts.init(dom);
        myChart.setOption(this.option)       
      },
  },
  mounted() {
     this.$nextTick(() => {
        this.setChart()
     })
  },
}
</script>

<style>

</style>